//loader
export default function ListNoData() {
 
  return (
  <>
    <div className="text-center">
      <p className="text-muted">No Records</p>
    </div>
  </>
  )
}